import { LastName } from '@dreryk/person-name-common-api';

import { FormContextValues, Validate } from '@dreryk/react-common';
import { LastNameInput } from '@dreryk/react-components';

const LAST_NAME_FIELD_NAME = 'lastName';

export type LastNameFormBeanPart = { [LAST_NAME_FIELD_NAME]: LastName | null };

type LastNameFieldProps = Pick<FormContextValues<LastNameFormBeanPart>, 'register'> & { readonly onValidate: Validate };

export const LastNameField = (props: LastNameFieldProps): JSX.Element => {
   return (
      <LastNameInput
         controller={props.register(LAST_NAME_FIELD_NAME, {
            maxLength: LastName.MAX_LENGTH,
            validate: props.onValidate,
         })}
         testId={LAST_NAME_FIELD_NAME}
      />
   );
};
